import "./ButtonPromotedItemBlock.scss";
import { ButtonPromotedItemBlockProps } from "/Models/Generated/ButtonPromotedItemBlockProps";
import { NoradTheme } from "/Models/Generated/NoradTheme";
import { ArrowCircleRightIcon, ArrowCircleUpRightIcon } from "/App.Components";
import { ColorTheme } from "/Models/Models/ColorTheme";
import { createSpreadableBem } from "/Helpers/createBem";

const ButtonPromotedItemBlock = ({
  link,
  description,
  theme,
}: ButtonPromotedItemBlockProps) => {
  const Icon = link?.isExternal ? ArrowCircleUpRightIcon : ArrowCircleRightIcon;

  if (!link || !link.href) {
    return null;
  }
  const bem = createSpreadableBem("button-promoted-item-block-norad");
  return (
    <a
      {...bem("", {
        "--primary": theme === NoradTheme.Primary,
        "--secondary": theme === NoradTheme.Secondary,
      })}
      href={link.href}
      aria-label={
        link.isExternal
          ? (link.externalLinkAriaPrefix ?? "") + (link.href ?? "")
          : undefined
      }
    >
      <div {...bem("__content")}>
        <h3 {...bem("__heading")}>
          <span>{link?.text}</span>
        </h3>
        {description && <span {...bem("__text")}>{description}</span>}
      </div>
      <div>
        <Icon size="32" thickness="Light" color={ColorTheme.default} />
      </div>
    </a>
  );
};

export default ButtonPromotedItemBlock;
